(function ($) {
    $(document).ready(function () {
        $('.tcu_page form.tcu_form input[type="checkbox"] + label span .underline').click(function(){
            // if($(this).prop("checked") == true){
                $('.tcu_popup').addClass('show');
                $('body.page-template-lu-calculator-template .tcu_popup .popup_inner').focus();
                // $('.tcu_agree_error').hide(); 
            // }
            // else{
            //     $('.tcu_agree_error').show();
            // }
            //luEnableDisapleButton();
            dataLayer.push({
                'step':'verify-terms',
                'funnelName':'Calculator',
                'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                'event':'changeStep'
            });
            //console.log(dataLayer);
        });
        $('.tcu_open_popup').click(function(e){
            e.preventDefault();
            $('.tcu_popup').addClass('show');
            $('body.page-template-lu-calculator-template .tcu_popup .popup_inner').focus();
        });
        $('.tcu_close_popup').click(function(e){
            e.preventDefault();
            $('.tcu_popup').removeClass('show');
            if($('.tcu_submit').length){
                $('.tcu_submit').focus().click();
            }
            else if($('.tco_submit').length){
                $('.tco_submit').focus().click();
            }
        });
        $('.tcu_close_popup').on('keydown',function(event) {
            if((event.keyCode || e.which) == 9){
            event.preventDefault();
            $(this).focus();
            }
        });
    });
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/popup.js